enum FormFields {
  Name = 'name',
  Market = 'market',
  PrimaryOrganization = 'primaryOrganization',
  Organizations = 'organizations',
  Prices = 'prices',
  Website = 'website',
  Place = 'place',
  SaleTeams = 'saleTeams',
  City = 'city',
  County = 'county',
  ZipCode = 'zipCode',
  Street = 'street',
  State = 'state',
  ContactPhone = 'contactPhone',
  ContactEmail = 'contactEmail',
  MainPropertyMediaId = 'mainPropertyMediaId',
  DefaultInventoryDetails = 'defaultInventoryDetails',
  AverageBedroomsNumber = 'averageBedroomsNumber',
  AverageBathroomsNumber = 'averageBathroomsNumber',
  AverageInteriorSqft = 'averageInteriorSqft',
  AverageExteriorSqft = 'averageExteriorSqft',
}

const FormFieldsList = [
  FormFields.Name,
  FormFields.Market,
  FormFields.PrimaryOrganization,
  FormFields.Organizations,
  FormFields.Prices,
  FormFields.Place,
  FormFields.SaleTeams,
  FormFields.Website,
  FormFields.ContactPhone,
  FormFields.ContactEmail,
  FormFields.County,
  FormFields.State,
  FormFields.City,
  FormFields.Street,
  FormFields.ZipCode,
  FormFields.MainPropertyMediaId,
  FormFields.DefaultInventoryDetails,
  FormFields.AverageBathroomsNumber,
  FormFields.AverageBedroomsNumber,
];

const SALE_TEAMS_FIELDS = [
  'saleTeamId',
  'saleDirectorId',
  'saleAssociateIds',
  'commission',
  'contactUrl',
];

export { FormFields, FormFieldsList, SALE_TEAMS_FIELDS };
